module.exports = __webpack_public_path__ + "img/cuttheprice.31fb5c0c.png";